import { useContext } from "react";
import { WhiteboardWebsocketContext } from "../contexts/WhiteboardWebsocketContext";

export const useWhiteboardWebsocket = () => {
  const {
    handleSendMessage,
    readyState,
    nextReference,
    handleSetNextReference,
    shouldScrollToBottom,
    displayLatestMessage,
    cleanShouldScrollToBottom,
    handleSetShouldScrollToBottom,
    handleNewList,
    handleNewMessages,
    handleSetMessageList,
    handleSetThreadMessageList,
    isLatestMessageExist,
    displayMessageList,
    messageList,
    isMessageLoading,
    setIsMessageLoading,
    isInitialMessageLoading,
    setIsInitialMessageLoading,
    handleMsgPreview,
    errorImage,
    errorImageSize,
    setErrorImageSize,
    typingUser,
    setTypingUser
  } = useContext(WhiteboardWebsocketContext);
  return {
    handleSendMessage,
    readyState,
    nextReference,
    handleSetNextReference,
    shouldScrollToBottom,
    displayLatestMessage,
    cleanShouldScrollToBottom,
    handleSetShouldScrollToBottom,
    handleNewList,
    handleNewMessages,
    handleSetMessageList,
    handleSetThreadMessageList,
    isLatestMessageExist,
    displayMessageList,
    messageList,
    isMessageLoading,
    setIsMessageLoading,
    isInitialMessageLoading,
    setIsInitialMessageLoading,
    handleMsgPreview,
    errorImage,
    errorImageSize,
    setErrorImageSize,
    typingUser,
    setTypingUser
  };
};
